<template>
  <!-- 소개, 사업개요 -->
  <div>
<!--    <header class="mb-4 pb-1 mb-md-5 pb-md-3">-->
<!--      <div-->
<!--        class="bg-img ratio-27 md-ratio-13 w-100 position-relative"-->
<!--        :style="{ backgroundImage: `url(${require('@/assets/platform/protocol/bg-introduce.png')})` }"-->
<!--      >-->
<!--        <div class="position-absolute text-center text-white" :style="{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }">-->
<!--          <small class="text-13">K-MAP Platform</small>-->
<!--          <h1 class="text-24 text-md-40 fw-600">소 개</h1>-->
<!--        </div>-->
<!--      </div>-->
<!--    </header>-->
    <div class="sub_top">
      <SubTitle></SubTitle>
      <div class="sub_tit">
        <div class="sub_tit_inner">
          <h2>사업개요</h2>
        </div>
      </div>
    </div>

    <!-- container : S -->
    <div class="ptc_container">
      <div class="info_section">
        <div class="info_txt">
          <p class="txt_typ_1">공유·활용체계를 구축하여 실시간으로 활용이 가능한 쉽고 원활한</p>
          <p class="txt_typ_2"><span class="txt_ib">측정·분석기술</span><span class="txt_ib">수집·관리·공유 서비스</span></p>
          <hr class="hr_line" />
          <p class="txt_typ_3">연구자 개개인이 습득·보유하고 있는 고난도 측정·분석 노하우를 프로토콜하여 이를 <strong>수집·축적 하여 공유·활용하고자 한다.</strong></p>
          <p class="txt_typ_3">
            이는 확장성을 고려한 표준화 측정분석 프로토콜 플랫폼의 기반이 되고 이를 통해 <strong>탐색설계 - 측정 분석-공정설계</strong>로 이어지는 3대 국가소재연구데이터센터의 핵심적
            역할을 수행할 것이다.
          </p>
        </div>
        <div class="info_graphic">
          <div class="info_graphic_img">
            <img :src="require(`@/style/new/images/info/overview_01.png`)" alt="" />
          </div>
        </div>
      </div>
    </div>
<!--    <section>-->
<!--      <b-container class="mb-5 pb-lg-3">-->
<!--        <content-header title="사업개요" />-->
<!--        <h2 class="text-center mt-lg-5 pt-lg-5 my-5 text-16 text-md-20 fw-600">-->
<!--          고난도 측정·분석노하우를 프로토콜化, <br />-->
<!--          공유·활용체계 구축, 실시간 활용-->
<!--        </h2>-->
<!--        <p class="mt-lg-5 text-14 text-lg-16 text-center lh-170 text-gray-6">-->
<!--          연구자 개개인이 습득·보유하고 있는 <br class="d-block d-md-none" />-->
<!--          <strong class="fw-600">고난도 측정·분석 노하우를 프로토콜化</strong> 하여, 이를-->
<!--          <strong class="fw-600">수집·축적하여 공유·활용</strong>하고자 한다. <br />-->
<!--          <br />-->
<!--          실시간 활용 및 업데이트가 가능한 <br class="d-block d-md-none" />-->
<!--          온라인 시스템으로 구축하여, <br />-->
<!--          쉽고 원활한 <strong class="fw-600">측정·분석기술 수집·관리·공유 서비스</strong>를 하는 것을 목표로 한다. <br />-->
<!--          <br />-->
<!--          이는 확장성을 고려한 <br class="d-block d-md-none" />-->
<!--          표준화 측정분석 프로토콜 플랫폼의 기반이 되고 <br />-->
<!--          이를 통해 <strong class="fw-600">탐색설계-측정분석-공정설계</strong>로 이어지는 <br class="d-block d-md-none" />-->
<!--          <strong class="fw-600">3대 국가소재연구데이터센터</strong>의 핵심적 역할을 수행할 것이다.-->
<!--        </p>-->
<!--      </b-container>-->
<!--      <div class="py-5" :style="{ backgroundColor: '#F5F6F9' }">-->
<!--        <middle-container class="mb-5 pb-5">-->
<!--          <h2 class="text-center text-18 text-md-26 fw-600 mb-5 pb-lg-3">플랫폼 구축체계</h2>-->
<!--          <img :src="require(`@/assets/platform/protocol/overview.png`)" class="w-100" />-->
<!--          &lt;!&ndash; <img :src="require(`@/assets/platform/protocol/overview.png`)" class="w-100 d-none d-xl-block" /> &ndash;&gt;-->
<!--          &lt;!&ndash; <img :src="require(`@/assets/platform/protocol/overview-m.png`)" class="w-100 d-block d-xl-none" /> &ndash;&gt;-->
<!--        </middle-container>-->
<!--      </div>-->
<!--    </section>-->
  </div>
</template>

<script>
import MiddleContainer from "@/components/platform/MiddleContainer";
import ContentHeader from "@/components/platform/ContentHeader";
import SubTitle from "@/views/Platform/Introduce/SubTitle";
export default {
  components: {
    MiddleContainer,
    ContentHeader,
    SubTitle,
  },
};
</script>

<style lang="scss" scoped></style>
